import { useEffect, useMemo, useRef, useState } from 'react'
import BreadCrumbs from '../../components/breadcrumb/Breadcrumb'
import PageDropdown from '../../components/page-dropdown/PageDropdown'
import { ROUTES_PATH } from '../../utility/constants'
import { convertDateFormatCalendar, convertTZToDate, dueFeesDetailsToExcel, generateDropdownOptions } from '../../utility/genricFunction'
import apiClient from '../../services/axois'
import Loader from '../../components/loader/Loader'
import { useDispatch, useSelector } from 'react-redux'
import * as Yup from 'yup'
import { VALIDATION_MESSAGES } from '../../utility/constantValidationMessages'
import { ErrorMessage, Form, Formik } from 'formik'
import Calendar from '../../components/calendar/Calendar'
import Button from '../../components/button/Button'
import SimCardDownloadIcon from '@mui/icons-material/SimCardDownload'
import PrintIcon from '@mui/icons-material/Print'
import ReportDataTable from '../../components/report-table/ReportDataTable'
import { getBatchFromBranch } from '../../store/builders/reports/reports.builder'
import { getBranchList, getCourse } from '../../store/builders/course/course.builder'
import { useReactToPrint } from 'react-to-print'
import { useLocation } from 'react-router-dom'

const TotalFees = () => {
  const location = useLocation();
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const [reportData, setReportData] = useState([])

  const branches = useSelector((state) => state?.branch?.branchTableData)
  const branchOption = useMemo(() => generateDropdownOptions(branches, 'branchName', 'branchId'), [branches])

  const batches = useSelector((store) => store.reports.batches)
  const batchOptions = useMemo(() => generateDropdownOptions(batches, 'batchNo', 'batchId'), [batches])

  const courses = useSelector((state) => state.course.course)
  const courseList = useMemo(() => generateDropdownOptions(courses, 'courseName', 'courseId'), [courses])
  const userRole = useSelector((state) => state.auth?.user?.result?.userData?.roleName) || {}
  const branchId = useSelector((state) => state.auth?.user?.result?.userData?.branchId)

  const [initialValues, setInitialValues] = useState({
    dueToDate: '',
    dueFromDate: '',
    branchName: userRole == 'branch' ? branchId : '',
    courseName: '',
    batchName: '',
  })
  const [isTableOpen, setIsTableOpen] = useState(false)

  useEffect(() => {
    dispatch(getCourse('publish'))
  }, [])

  useEffect(() => {
    // Extract query parameters from URL
    if(location.search){
    const queryParams = new URLSearchParams(location.search)
    const dueFromDate = queryParams.get('dueFromDate') || ''
    const dueToDate = queryParams.get('dueToDate') || ''
    const branchName = queryParams.get('branchName') || null
    const courseName = queryParams.get('courseName') || null
    const batchName = queryParams.get('batchName') || null
    if (queryParams.has('someParam')) {
      setIsTableOpen(true)
    }
    if (dueFromDate || dueToDate) {
      const convertToISOFormat = (date) => {
        if (!date) return ''
        const dateObj = new Date(date)
        return dateObj.toISOString()
      }
      // `${dueToDate}T23:59:59.000Z`
      setInitialValues((prevValues) => ({
        ...prevValues,
        dueToDate: !dueToDate ? ''  : convertToISOFormat(dueToDate),
        dueFromDate: !dueFromDate ?  '': convertToISOFormat(dueFromDate),
        branchName,
        courseName,
        batchName,
      }))

      if(!dueFromDate && dueToDate){
        const dueFromDate = null
        handleFormSubmit({
          dueFromDate,
          dueToDate,
          branchName,
          courseName,
          batchName,
        })
      } else {
        handleFormSubmit({
          dueFromDate,
          dueToDate,
          branchName,
          courseName,
          batchName,
        })
      }

    }

    dispatch(getCourse('publish'))
  }else{
    setInitialValues({
      dueToDate: '',
      dueFromDate: '',
      branchName: '',
      courseName: "",
      batchName: "",
    })
    setIsTableOpen(false)

  }
  }, [location])

  const validationSchema = Yup.object().shape({
    dueToDate: Yup.string().required(VALIDATION_MESSAGES.DATE),
    dueFromDate: Yup.string().required(VALIDATION_MESSAGES.DATE),
  })
  function getFormattedDate(date) {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
  }

  const handleFormSubmit = async (values) => {
    setLoading(true)
    const dueFromDate = values.dueFromDate ? new Date(values.dueFromDate) : null
    const dueToDate = values.dueToDate ? new Date(values.dueToDate) : null

    const branchName = branchOption.find((option) => option.value === values.branchName)?.label
    const courseName = courseList.find((option) => option.value === values.courseName)?.label
    const batchName = batchOptions.find((option) => option.value === values.batchName)?.label

    const formattedDueFromDate = dueFromDate ? getFormattedDate(dueFromDate) : null
    const formattedDueToDate = dueToDate ? getFormattedDate(dueToDate) : null

    const payload = {
      dueFromDate: formattedDueFromDate,
      dueToDate: formattedDueToDate,
      branchName: branchName || null,
      courseName: courseName || null,
      batchName: batchName || null,
    }

    try {
      const url = '/student/fee-due-collection'
      const response = await apiClient.post(url, payload)
      if (response.status) {
        setReportData(response.data.result)
        setIsTableOpen(true)
        setLoading(false)
      }
    } catch (error) {
      console.error('Error fetching data:', error)
    }
  }

  const dateBody = (reportData) => {
    const representative = reportData?.paymentDue && convertTZToDate(reportData?.paymentDue)
    return (
      <div className='flex align-items-center gap-2'>
        <span>{representative}</span>
      </div>
    )
  }

  const breadCrumbsArr = [
    {
      title: 'Fees Outstanding',
      link: null,
    },
    {
      title: 'Dashboard',
      link: ROUTES_PATH.DASHBOARD,
    },
    {
      title: 'Fees Outstanding',
      link: ROUTES_PATH.TOTAL_DUE_FEES,
    },
  ]
  const columns = [
    
    {
      field: 'studentName',
      header: 'student Name',
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '8rem' },
      // body: dateBody
    },
    {
      field: 'phone',
      header: 'Phone',
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '8rem' },
    },
    {
      field: 'paymentDue',
      header: 'Due Date',
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '8rem' },
      body: dateBody,
      dataType: 'date',
    },
    {
      field: 'branchName',
      header: 'Branch',
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '8rem' },
    },
    {
      field: 'batchNo',
      header: 'Batch',
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '8rem' },
    },
    {
      field: 'courseName',
      header: 'Course Name No',
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '8rem' },
    },
    {
      field: 'dueAmount',
      header: 'Due Amount',
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '8rem' },
    },
    {
      field: 'totalFees',
      header: 'Total Fees',
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '8rem' },
    },
  ]

  const printRef = useRef()

  const handleDownloadPfd = useReactToPrint({
    content: () => printRef.current,
  });

  const handleCourseChange = (value, setFieldValue) => {
    setFieldValue('courseName', value)
    dispatch(getBranchList({ courseId: value }))
  }
  const handleBranchChange = (value, setFieldValue) => {
    setFieldValue('branchName', value)
    dispatch(getBatchFromBranch(value))
  }

  return (
    <>
      {loading && <Loader loading={loading} />}
      {<Loader loading={loading} /> && (
        <div className='feesCollectionReport-wrapper'>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values) => {
              handleFormSubmit(values)
            }}
            enableReinitialize
          >
            {({ values, handleChange, handleSubmit, setFieldValue }) => (
              <Form>
                <div className='feesCollectionReport-header'>
                  <BreadCrumbs breadCrumbsArr={breadCrumbsArr} />
                </div>

                <div className='feesCollectionReport'>
                  <div className='feesCollectionReport-input-fields'>
                    <Calendar
                      label='From Date'
                      name='dueFromDate'
                      width={'100%'}
                      required={true}
                      value={values.dueFromDate}
                      onChange={(values) => setFieldValue('dueFromDate', convertDateFormatCalendar(values))}
                    />

                    <Calendar
                      label='To Date'
                      name='dueToDate'
                      width={'100%'}
                      required={true}
                      value={values.dueToDate}
                      onChange={(values) => setFieldValue('dueToDate', convertDateFormatCalendar(values))}
                    />
                    <div className='feesCollectionReport-input'>
                      <label htmlFor=''>
                        Course
                      </label>
                      <PageDropdown
                        options={courseList}
                        selectedValue={values.courseName}
                        className={'feesCollectionReport-dropdown'}
                        onChange={(e) => handleCourseChange(e.target.value, setFieldValue)}
                        name={'courseName'}
                        placeholder={'Select Course'}
                        // disabled={userRole == "branch"}
                      />
                      <ErrorMessage name='courseName' component='div' className='error-msg' />
                    </div>
                    <div className='feesCollectionReport-input'>
                      <label htmlFor=''>
                        Branch
                      </label>
                      <PageDropdown
                        options={branchOption}
                        selectedValue={values.branchName}
                        className={'feesCollectionReport-dropdown'}
                        onChange={(e) => handleBranchChange(e.target.value, setFieldValue)}
                        name={'branchName'}
                        placeholder={'Select Branch'}
                        // disabled={userRole == "branch"}
                      />
                      <ErrorMessage name='branchName' component='div' className='error-msg' />
                    </div>
                    <div className='feesCollectionReport-input'>
                      <label htmlFor=''>
                        Batch
                      </label>
                      <PageDropdown
                        options={batchOptions}
                        selectedValue={values.batchName}
                        className={'feesCollectionReport-dropdown'}
                        onChange={handleChange}
                        name={'batchName'}
                        placeholder={'Select Batch'}
                        // disabled={userRole == "branch"}
                      />
                      <ErrorMessage name='batchName' component='div' className='error-msg' />
                    </div>
                  </div>

                  <div className='report-submit-div'>
                    <Button customClassName={'save-btn'} onClick={handleSubmit}>
                      Submit
                    </Button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>

          {isTableOpen && (
            <div className='feesCollectionReport-table'>
              <div className='export-option-wrapper'>
                <div className='pdf-excel-export'>
                  <Button
                    text={'Export'}
                    type={'button'}
                    disabled={reportData?.length > 0 ? false : true}
                    onClick={() => dueFeesDetailsToExcel(reportData, '', 'Due fess Details', 'DueFessReport.xlsx')}
                  >
                    <SimCardDownloadIcon />
                  </Button>

                  <Button
                    text={'Export'}
                    type={'button'}
                    onClick={handleDownloadPfd}
                    disabled={reportData?.length > 0 ? false : true}
                  >
                    <PrintIcon />
                  </Button>
                </div>
              </div>

              <div ref={printRef} className=''>
                <ReportDataTable
                  columns={columns}
                  value={reportData}
                  // loading={loading}
                  // footerColumnGroup={footerGroup}
                />
              </div>
            </div>
          )}
        </div>
      )}
    </>
  )
}
export default TotalFees
